import { ContactSupportTwoTone } from "@material-ui/icons";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, call, takeLatest } from "redux-saga/effects";
import { getUserByToken, getUserById } from "./authCrud";
const API_URL = "https://graphql.brandsolo.com/v1/graphql";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  Simulate: "[Simulate] Action",
  StopSimulate: "[StopSimulate] Action",
  DecorateAdmin: "[DecorateAdmin] Action",
  UnDecorateAdmin: "[UnDecorateAdmin] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
};

export const reducer = persistReducer(
  { storage, key: "brandsolo-auth", whitelist: ["user", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {

        const { authToken } = action.payload;

        const user = {
          id: authToken.id,
          email: authToken.email,
          username: authToken.email,
          firstname: "",
          lastname: "",
          name: authToken.name,
          roles: parseInt(authToken.user_role) === 0 ? [0] : [3],
          accessToken: "access-token-" + Math.random(),
          refreshToken: "access-token-" + Math.random(),
          client: parseInt(authToken.user_role) === 0 ? {} : {id: authToken.client.id, currency: authToken.client.currency, demo: authToken.client.demo},
          pic: process.env.PUBLIC_URL + "/media/users/default.jpg"
        };


        return { authToken: authToken.email, user:  user };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
       
      }

      case actionTypes.SetUser: {
       
      }

      case actionTypes.Simulate: {
        const { id } = action.payload;
        return { ...state, id };
      }

      case actionTypes.StopSimulate: {
        return { ...state };
      }

      case actionTypes.DecorateAdmin: {
        const { newUser, user } = action.payload;

        user.simulate = newUser;
        user.client.id = newUser.client.id;
        user.client.currency = newUser.client.currency;
        user.client.demo = newUser.client.demo;

        return { ...state, user };
      }

      case actionTypes.UnDecorateAdmin: {
        const { user } = action.payload;

        user.simulate = null;
        user.client = {};

        return { ...state, user };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  simulate: (id) => ({
    type: actionTypes.Simulate,
    payload: { id },
  }),
  stopSimulate: () => ({ type: actionTypes.StopSimulate }),
  decorateAdmin: (newUser, user) => ({ type: actionTypes.DecorateAdmin, payload: { newUser, user } }),
  unDecorateAdmin: (user) => ({ type: actionTypes.UnDecorateAdmin, payload: { user } }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));
  });

  yield takeLatest(actionTypes.Simulate, function* userRequested(data) {
    const { id } = data.payload;
    const { data: user } = yield getUserByToken();

    const result = fetch(
      API_URL, {
      method: "POST",
      body: JSON.stringify({
        query: `
            query brandSoloQuery($id: Int!) {
              users(where: {id: {_eq: $id}}) {
                email
                id
                name
                fullname: name
                username: name
                token
                client {
                  id
                  demo
                  currency
                }
              }
            }
          `,
        variables: {
          id: id
        }
      })
    }
    );

    const promise = new Promise((resolve, reject) => {
      resolve(result);
    });

    const yieldedPromise = yield promise;

    const newUser = new Promise((resolve, reject) => {
      const data = yieldedPromise.json();
      resolve(data);
    });

    const resultUser = yield newUser;
    
    yield put(actions.decorateAdmin(resultUser.data.users[0], user));
  });

  yield takeLatest(actionTypes.StopSimulate, function* userRequested(data) {
    const { data: user } = yield getUserByToken();

    yield put(actions.unDecorateAdmin(user));
  });
}
